const GOOD_TOAST_MS = 5_000;

/** Root-owned transient notices. Good news auto-dismisses; problems stay until dismissed, replaced or cleared. */
export class Toasts {
  message = $state('');
  good = $state(false);
  /** Increments per show so identical consecutive messages re-announce. */
  id = $state(0);
  private timer = 0;

  show(message: string, good = false): void {
    this.message = message;
    this.good = good;
    this.id++;
    window.clearTimeout(this.timer);
    if (!good) return;
    this.timer = window.setTimeout(() => {
      this.message = '';
    }, GOOD_TOAST_MS);
  }

  dismiss(): void {
    this.message = '';
    window.clearTimeout(this.timer);
  }

  dispose(): void {
    window.clearTimeout(this.timer);
  }
}
